import cookie from 'cookie';

type PreviewCookieOptions = {
  asAtDate?: string;
  asAtTime?: string;
  dataset?: string;
  mode?: string;
};

const COOKIE_NAME = 'cms_preview';
const COOKIE_MAX_AGE = 60 * 60 * 24; // 24 hours

const setPreviewCookie = (options: PreviewCookieOptions) => {
  const { asAtDate, asAtTime, dataset, mode } = options;
  document.cookie = cookie.serialize(COOKIE_NAME, JSON.stringify({ asAtDate, asAtTime, dataset, mode }), {
    maxAge: COOKIE_MAX_AGE,
    path: '/',
    sameSite: 'lax',
  });
};

const getPreviewOptionsFromCookieHeader = (cookieHeader?: string): PreviewCookieOptions | null => {
  if (!cookieHeader) return null;
  const cookies = cookie.parse(cookieHeader);
  if (!cookies[COOKIE_NAME]) return null;
  try {
    return JSON.parse(cookies[COOKIE_NAME]);
  } catch {
    return null;
  }
};

export { getPreviewOptionsFromCookieHeader, setPreviewCookie };
